// Blocked
import BlockedInflux from "@/templates/innflux_final/Blocked";

// Meeting
import MeetingInflux from "@/templates/innflux_final/Meeting";

// No Meeting
import NoMeetingInflux from "@/templates/innflux_final/NoMeeting";

// Session
import SessionInflux from "@/templates/innflux_final/Session";

// Transport 
import TransportInflux from "@/templates/innflux_final/Transport";

// Welcome
import WelcomeInflux from "@/templates/innflux_final/Welcome";

const mappings = [];

mappings['blocked'] = {
	BlockedInflux
}; 

mappings['meeting'] = {
	MeetingInflux
};

mappings['nomeeting'] = {
	NoMeetingInflux
};

mappings['session'] = {
	SessionInflux
};

mappings['transport'] = {
	TransportInflux
};

mappings['welcome'] = {
	WelcomeInflux
};

export default mappings;